import Vue from "vue";
import set from "lodash/set";
import get from "lodash/get";
import { nombreMotorTagging } from "@/utils";
import { AdobeFunctions } from "./utils/adobeFunctions";

const AdobeHogar = {
  enable() {},
  wait() {
    return !!window._satellite && document.readyState !== "complete";
  },
  init(context) {
    AdobeFunctions.internal(context, () => {
      Vue.$log.info("🚀 Adobe Launch working");
    });
  },
  appStarted(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding home insurance simulator"
      );
      AdobeFunctions.setPageName("1 inicio");
      AdobeFunctions.setCommonProductAttributes();
      set(window.digitalData, "application.step", "1 inicio");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(
        window.digitalData,
        "application.step",
        get(context.mutation.payload, "appStep", "")
      );
      AdobeFunctions.callAdobeDTM("digitalLink", "App Started");
    });
  },
  appOnClickStart(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setCommonProductAttributes(
        get(context, "state.cotizacionHogar.sumaAsegurada", "")
      );
      set(window.digitalData, "application.step", "continuar");
      set(window.digitalData, "application.fulfillmentModel", "online");
      set(window.digitalData, "application.application.type", "contratacion");
      set(
        window.digitalData,
        "application.globalApplication",
        "home insurance"
      );
      set(
        window.digitalData,
        "application.application.name",
        "contratar seguro hogar"
      );
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      AdobeFunctions.callAdobeDTM("digitalLink", "App On Click Start");
    });
  },
  errorPage(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("error servicio");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.errorPage", "error servicio");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  verificacion(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding home insurance simulator"
      );
      AdobeFunctions.setCommonProductAttributes();
      AdobeFunctions.setProductState("rechazado");
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.state", "rechazado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "user.segment.profile", "usuario no cliente");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  internalLink(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName(get(context.mutation.payload, "level2", ""));
      set(
        window.digitalData,
        "page.pageActivity.link.name",
        get(context.mutation.payload, "name", "")
      );
      AdobeFunctions.callAdobeDTM("digitalLink", "Internal Link");
    });
  },
  modal(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName(get(context.mutation.payload, "name", ""));
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  paso1(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding home insurance simulator"
      );
      AdobeFunctions.setPageName("1 inicio");
      AdobeFunctions.setCommonProductAttributes();
      set(window.digitalData, "application.step", "1 inicio");
      set(window.digitalData, "application.isQualifiedVisits", "true");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Page Visit");
    });
  },
  paso2(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding home insurance simulator"
      );
      AdobeFunctions.setPageName("2 datos");
      AdobeFunctions.setCommonProductAttributes();
      set(window.digitalData, "application.step", "2 datos");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  paso3(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding home insurance simulator"
      );
      AdobeFunctions.setPageName("3 coberturas");
      AdobeFunctions.setCommonProductAttributes();
      set(window.digitalData, "application.step", "3 coberturas");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  paso4(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding home insurance simulator"
      );
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setCommonProductAttributes(
        get(context, "state.cotizacionHogar.sumaAsegurada", "")
      );
      set(window.digitalData, "application.state", "finalizado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  }
};
export default AdobeHogar;
